var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pedidosOffline.length > 0)?_c('v-card',{attrs:{"flat":""}},[_c('v-alert',{staticClass:"body-1",attrs:{"type":"warning","outlined":"","text":""}},[_c('h3',[_vm._v("Atenção")]),_vm._v(" Existem pedidos emitidos que precisam ser sincronizados ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }